export default "__VITE_ASSET__CWPBbHVG__"